import { motion } from 'framer-motion';
import { FC, ReactNode } from 'react';

type StaggerFadeInProps = {
  children: ReactNode;
  className?: string;
};

export const StaggerFadeIn: FC<StaggerFadeInProps> = ({ children, className }) => (
  <motion.div
    animate="visible"
    className={className}
    initial="hidden"
    variants={{
      hidden: {},
      visible: { transition: { staggerChildren: 0.06 } },
    }}
  >
    {children}
  </motion.div>
);
